import { render, staticRenderFns } from "./MailingLists.vue?vue&type=template&id=35e537e8&scoped=true"
import script from "./MailingLists.ts?vue&type=script&lang=js&external"
export * from "./MailingLists.ts?vue&type=script&lang=js&external"
import style0 from "./MailingLists.scss?vue&type=style&index=0&id=35e537e8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e537e8",
  null
  
)

export default component.exports